var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 66,
    viewBox: "0 0 68 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fe3636;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #0052d9;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_5360",
    "data-name": "\\u7EC4 5360",
    transform: "translate(-247 -90.201)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_742",
    "data-name": "\\u77E9\\u5F62 742",
    className: "cls-1",
    width: 54,
    height: 51,
    rx: 5,
    transform: "translate(247 90.201)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_743",
    "data-name": "\\u77E9\\u5F62 743",
    className: "cls-2",
    width: 52,
    height: 50,
    rx: 5,
    transform: "translate(263 106.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_3894",
    "data-name": "\\u8DEF\\u5F84 3894",
    className: "cls-3",
    d: "M-17321.486,4647.55h37.6l-18.221,25.806h19.373v9.894h-38.748l19.375-25.559h-19.375Z",
    transform: "translate(17584.209 -4541.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_3895",
    "data-name": "\\u8DEF\\u5F84 3895",
    className: "cls-1",
    d: "M-17215.59,4670h21.033l-19.719,25.624Z",
    transform: "translate(17476.996 -4554.347)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d7a1636deb1694007d4271da6b214ca8.svg";
export { ForwardRef as ReactComponent };